import React, { useEffect } from 'react'

const DurexRichMedia = () => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://media.adcanvas.com/j2bUJi4LYLtk/adtag.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        //     <div dangerouslySetInnerHTML={{
        //         __html: `<ins class="adcads" data-adc-id="j2bUJi4LYLtk" data-unit="j2bUJi4LYLtk" data-clickable="yes" data-redir="yes"
        //     data-click-tracker="[ADS_CLICK_URL]" data-click-macro="[ADS_CLICK_URL]" data-has-desktop="yes"
        //     data-responsive="yes" data-width="300" data-height="300">
        //     <script src="https://media.adcanvas.com/j2bUJi4LYLtk/adtag.js" type="text/javascript" async></script>
        // </ins>` }} className='block'></div>
        <ins
            className="adcads"
            data-adc-id="j2bUJi4LYLtk"
            data-unit="j2bUJi4LYLtk"
            data-clickable="yes"
            data-redir="yes"
            data-click-tracker="https://dochase.com"
            data-click-macro="https://dochase.com"
            data-has-desktop="yes"
            data-responsive="yes"
            data-width="300"
            data-height="300"
        ></ins>
    )
}

export default DurexRichMedia